import { Widgets } from "@mui/icons-material";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import loginBg from "../assets/loginbg.jpg";

const AuthLayout = () => {
  return (
    <Box className="min-h-screen h-full flex items-center justify-center bg-0000006e" height="100vh" 
     
    >
      <Box className="w-full max-w-md shadow-md rounded-lg" height="100vh" sx={{
         backgroundImage: {
            xs: 'none',
            sm: 'none', 
            md: `url(${loginBg})`,
          },
        backgroundSize: "50% 100%",
        backgroundPosition: "right",
        backgroundRepeat: "no-repeat",
        
      }}>
        <Box className="shadow-md" sx={{px:4,py:2}}>
        <img
        style={{ width: '16%' }}
        srcSet={`/kfdmain.png`}
        src={`/kfdmain.png`}
        alt={"KFD logo"}
        loading="lazy"
        />
        </Box>


        <Outlet />
      </Box>
    </Box>
  );
};

export default AuthLayout;
